import React from 'react';
import People from './People';
import { peopleInfo } from './AboutData';

const Bio = () => {
  const items = React.useMemo(
    () => peopleInfo.sort(() => Math.random() - 0.5),
    []
  );

  return (
    <div className="bg-gray-50">
      {/* This new wrapper centers the content, sets a max-width, and adds
        responsive padding that increases on larger screens (px-4 -> sm:px-6 -> lg:px-8)
      */}
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <h1 className="text-center text-4xl sm:text-5xl font-bold text-gray-800">
          ✨ Meet Our Team ✨
        </h1>

        {/* The padding class was removed from here and a top margin was added */}
        <div className="mt-16 flex flex-col items-center gap-12">
          {items.map((item) => (
            <People key={item.id} person={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bio;
